var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93341 16.4642C3.69946 17.1129 2.66048 16.3589 2.89628 14.9841L3.6043 10.856C3.60892 10.8291 3.57507 10.7255 3.55578 10.7067L0.556532 7.78312C-0.441756 6.81003 -0.0457385 5.58891 1.33465 5.38833L5.47951 4.78605C5.5065 4.78212 5.59463 4.7179 5.60655 4.69374L7.46019 0.937864C8.07716 -0.312265 9.3609 -0.312978 9.97822 0.937864L11.8319 4.69374C11.8439 4.7182 11.9322 4.78217 11.9589 4.78605L16.1038 5.38833C17.4834 5.5888 17.8807 6.80948 16.8819 7.78312L13.8826 10.7067C13.8631 10.7257 13.8296 10.8295 13.8341 10.856L14.5421 14.9841C14.7778 16.3582 13.7397 17.1133 12.505 16.4642L8.79772 14.5152C8.77358 14.5025 8.66453 14.5026 8.64069 14.5152L4.93341 16.4642Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.ff02f6b2f860a5f30e3f6336fc828e02.svg";
export { ForwardRef as ReactComponent };